/************************************
1. If you want to add or remove items you will need to change a variable called $slide-count in the CSS *minimum 3 slides

2. if you want to change the dimensions of the slides you will need to edit the slideWidth variable here 👇 and the $slide-width variable in the CSS.
************************************/
import React from "react";
// import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const options = {
  responsive: {
    0: {
      items: 1,
    },
    400: {
      items: 1,
    },
    600: {
      items: 2,
    },
    700: {
      items: 2,
    },
    1000: {
      items: 3.5,
    },
  },
};

const Designers = () => {
  return (
    <>
      <div className="roadmap_section designer_mob">
        {/* <h2
          className="head_pt main_banner-heading"
          style={{ textAlign: "left", paddingLeft: "0" }}
        >
          Roadmap
        </h2> */}
        {/* <!-- live auctions --> */}
        <section className="inner">
          {/* <!-- title --> */}
          {/* <div className="col-12">
            <div className="main__title">
              <h2><a href="#">Latest Chords</a></h2>
            </div>
          </div> */}
          {/* <!-- end title --> */}

          {/* carousel  */}
          <div className="col-12">
            <OwlCarousel
              className="owl-theme hero chords"
              loop
              margin={10}
              nav
              id="hero"
              autoheight="true"
              {...options}
              style={{ marginTop: "0", padding: "28px 0px 0px 0px" }}
            >
              <div className="team_member">
                <img
                  src={"images/new/Art_Director_Agent_Doomy.png"}
                  alt=""
                  onClick={() => window.open("https://twitter.com/loomi_eth")}
                ></img>
                <strong
                  onClick={() => window.open("https://twitter.com/loomi_eth")}
                >
                  Art Director
                  {/* <Twitter size={13} color="#ffffff" /> */}
                </strong>
                <span
                  onClick={() => window.open("https://twitter.com/loomi_eth")}
                >
                  Agent Loomy
                </span>
                <div className="team_overlay"></div>
              </div>
              <div className="team_member">
                <img src={"images/new/Designer_Agent_Keedle.png"} alt=""></img>
                <strong
                  onClick={() => window.open("https://twitter.com/keedle_eth")}
                >
                  Designer Agent
                  {/* <Twitter size={13} color="#ffffff" /> */}
                </strong>
                <span
                  onClick={() => window.open("https://twitter.com/keedle_eth")}
                >
                  Agent Keedle
                </span>
                <div className="team_overlay"></div>
              </div>
              <div className="team_member">
                <img
                  src={"images/new/Community_Manager_Agent_Liam.png"}
                  alt=""
                  onClick={() => window.open("https://twitter.com/liiam_eth")}
                ></img>
                <strong
                  onClick={() => window.open("https://twitter.com/liiam_eth")}
                >
                  Community Manager
                  {/* <Twitter size={13} color="#ffffff" /> */}
                </strong>
                <span
                  onClick={() => window.open("https://twitter.com/liiam_eth")}
                >
                  Agent Liam
                </span>
                <div className="team_overlay"></div>
              </div>
              <div className="team_member">
                <img
                  src={"images/new/IT_Director_Agent_Cozomo.png"}
                  alt=""
                  onClick={() => window.open("https://twitter.com/Cozomo_eth")}
                ></img>
                <strong
                  onClick={() => window.open("https://twitter.com/Cozomo_eth")}
                >
                  IT Director
                  {/* <Twitter size={13} color="#ffffff" /> */}
                </strong>
                <span
                  onClick={() => window.open("https://twitter.com/Cozomo_eth")}
                >
                  Agent Cozomo
                </span>
                <div className="team_overlay"></div>
              </div>
            </OwlCarousel>
          </div>
          {/* end carousel  */}
        </section>
        {/* end live auctions */}
      </div>
    </>
  );
};

export default Designers;
